import * as Yup from 'yup';

export const schema = (messages: any) =>
  Yup.object().shape({
    value: Yup.string().required(
      messages['productRejectionReasons.update.option.nameRequired'].toString(),
    ),
  });
